module.exports = __webpack_public_path__ + "static/media/card-logo-mastercard.11f52389.svg";